import type { TypePaletteColor } from '@/types/ui/types.ui.palette';

export const PALETTE_COLORS: TypePaletteColor[] = ['red', 'orange', 'yellow', 'green', 'blue', 'purple', 'gray', 'none'];
